module.exports = __webpack_public_path__ + "img/footlogo.4e748fa9.png";